import { isProduction } from '@/consts/env';

/**
 * Vercel Preview(*.preview.zep.us) 호스트인지 런타임으로 판별한다.
 *
 * 프리뷰 배포는 prod 와 동일하게 `NEXT_PUBLIC_STAGE=PRD` 로 빌드되므로(deploy-preview.yml 이
 * STAGE 를 override 하지 않고 Vercel Preview 스코프 기본값을 씀) 빌드타임 env 만으로는
 * 프리뷰와 진짜 prod 를 구분할 수 없다. 그래서 런타임 호스트명으로 프리뷰를 식별한다.
 * (auth.ts `buildAuthAppSigninUrl` 의 preview 판별과 동일 패턴)
 */
export const isPreviewHost = (): boolean =>
  typeof window !== 'undefined' &&
  /\.preview\.zep\.us$/.test(window.location.hostname);

/**
 * QA 툴박스를 이 환경에서 켤 수 있는지 여부.
 *
 * prod 서비스 호스트(quiz.zep.us 등)에서만 숨기고, dev/stage/loc 및 Vercel Preview 에서는 켠다.
 * 프리뷰는 STAGE=PRD 로 빌드되지만 실제로는 QA 검증 환경이므로 노출한다.
 */
export const isQaToolboxEnvEnabled = (): boolean =>
  !isProduction || isPreviewHost();
